/**
 * Cookie Consent Model
 * Models for managing cookie consent state and Clarity analytics consent
 */

/**
 * Cookie consent state stored in localStorage
 */
export interface CookieConsentState {
  analyticsConsent: boolean;
  timestamp: string;
  hasResponded: boolean;
}

/**
 * Microsoft Clarity Consent API interface
 * Reference: https://learn.microsoft.com/en-us/clarity/setup-and-installation/clarity-consent-api-v2
 */
export interface ClarityConsentAPI {
  consent?: () => void;
}

/**
 * Extended window interface for Clarity
 */
declare global {
  interface Window {
    clarity?: (action: string, ...args: any[]) => void;
  }
}

/**
 * Cookie consent configuration
 */
export const COOKIE_CONSENT_CONFIG = {
  STORAGE_KEY: "roomonitor_cookie_consent",
  ANALYTICS_CONSENT_GRANTED: "granted",
  ANALYTICS_CONSENT_DENIED: "denied",
} as const;
